import { useAppStore, useCmsStore } from "@/components/AppHooks";
import { QuizMaster } from "./master";
import { QuizSmirnoff } from "./smirnoff";
import { QuizTanqueray } from "./tanqueray";
import { styleName } from "@/config/const";
import { TQuizProps, TQuizTanquerayProps } from "./type";
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { quizInitCallFp } from "./api";
import { tracking } from "@/shared/tracking";
import { getSessionToken } from "@/shared/utils";
export function Quiz(props: {
    component: Array<TQuizProps | TQuizTanquerayProps>
}) {
    const { storeConfig, locale } = useCmsStore()!
    const { storeStyleName = styleName.Master } = storeConfig
    const pageProps = props.component.find((item) => item.storeStyleName === storeStyleName)
    const { resetAnswer, resetResults, resetSecondResults } = useAppStore();
    const router = useRouter()
    useEffect(() => {
        resetAnswer()
        resetResults()
        resetSecondResults()
        getSessionToken(true)
        localStorage.removeItem('secondCocktailList')
        localStorage.removeItem('cocktailList')
        router.prefetch(`/${locale}/results`)
        quizInitCallFp(storeConfig)
    }, [router, locale])
    useEffect(() => {
        tracking({
            "event": "custom_event",
            "event_name": "quiz_start"
        })
        tracking({
            "event": "custom_event",
            "event_name": "quiz_step",
            "step": "question 1"
        })
    }, [])
    return (
        <>
            {storeStyleName === styleName.Master && <QuizMaster {...pageProps as TQuizProps} />}
            {storeStyleName === styleName.SmirnoffKenya && <QuizSmirnoff {...pageProps as TQuizProps} />}
            {storeStyleName === styleName.Tanqueray && <QuizTanqueray {...pageProps as TQuizTanquerayProps} />}
        </>
    );
}